<div class="PGFilePicker">
    @if (isLoading) {
        <app-pg-loading></app-pg-loading>
    }
    @if (!isLoading) {
        <div class="container-fluid p-0">
            @if (!readonly) {
                <div class="row mb-1">
                    <div class="col-12">
                        <div class="d-flex">
                            <div>
                                <app-pg-upload-button buttonText="{{ 'pg-file-picker.upload' | locTranslate }}" buttonIcon="fa-regular fa-upload" [fileType]="fileType" [accept]="acceptString" [multiple]="multi" (setFiles)="setFiles($event)"></app-pg-upload-button>
                            </div>
                            <div class="ms-2">
                                <button type="button" class="btn btn-primary" (click)="modalLinkOpen()">
                                    <i class="fa-regular fa-paste" aria-hidden="true"></i>
                                    <span>{{ 'pg-file-picker.link' | locTranslate }}</span>
                                </button>
                            </div>
                            @if (canSelectFile) {
                                <div class="ms-2">
                                    <app-pg-resource-picker resourceId="File" [selectionMode]="multi ? 'multi' : 'single'" selectionField="url" [forceRealm]="forceRealm" [(selection)]="resourcePickerSelection" (selectionChange)="onResourcePickerSelectionChange()" customContent="true" [filterStatus]="resourcePickerFilterStatus">
                                        <button type="button" class="btn btn-primary">
                                            <i class="fa-regular fa-hand-pointer" aria-hidden="true"></i>
                                            <span>{{ 'pg-file-picker.select' | locTranslate }}</span>
                                        </button>
                                    </app-pg-resource-picker>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            }
            @if ((alreadyLoaded != null && alreadyLoaded.length > 0) || (selectedFiles != null && selectedFiles.length > 0)) {
                <div class="PGFilePicker-Preview {{ hasEditFile() ? 'PGFilePicker-Preview--HasEditFile' : '' }} mt-1 row">
                    @if (alreadyLoaded != null && (multi || selectedFiles == null || selectedFiles.length == 0)) {
                        @for (file of alreadyLoaded; track file) {
                            <div class="PGFilePicker-Item {{ file.deleted ? 'PGFilePicker-Item--Deleted' : '' }} col-12 {{ multi ? 'col-sm-6 col-md-4' : '' }}">
                                <app-pg-file-preview [fileData]="file" [viewMode]="fileType"></app-pg-file-preview>
                                <div class="PGFilePicker-Item-Actions">
                                    @if (extraActions != null) {
                                        @for (action of extraActions; track action) {
                                            <button type="button" class="btn btn-sm btn-{{action.color}} ms-1" [disabled]="isSaving" [attr.aria-label]="action.name" (click)="$event.stopPropagation(); $event.preventDefault(); onExtraAction.emit({ action: action.name, file: file.url })">
                                                <i class="fa-regular {{action.icon}}" aria-hidden="true"></i>
                                            </button>
                                        }
                                    }
                                    @if (hasEditFile()) {
                                        <button type="button" class="btn btn-sm btn-primary ms-1" [disabled]="isSaving || file.deleted" [attr.aria-label]="'pg-file-picker.a11y.edit' | locTranslate" (click)="$event.stopPropagation(); $event.preventDefault(); editFile(file)">
                                            <i class="fa-regular fa-edit" aria-hidden="true"></i>
                                        </button>
                                    }
                                    @if (!readonly && !autoConfirm) {
                                        <button type="button" class="btn btn-sm {{ file.deleted ? 'btn-secondary' : 'btn-danger' }} ms-1" [disabled]="isSaving" [attr.aria-label]="(file.deleted ? 'pg-file-picker.a11y.restore' : 'pg-file-picker.a11y.delete') | locTranslate" (click)="$event.stopPropagation(); $event.preventDefault(); toggleAlreadyUploadedDelete(file)">
                                            @if (!file.deleted) {
                                                <i class="fa-regular fa-trash" aria-hidden="true"></i>
                                            }
                                            @if (file.deleted) {
                                                <i class="fa-regular fa-undo" aria-hidden="true"></i>
                                            }
                                        </button>
                                    }
                                    @if (!readonly && autoConfirm) {
                                        <app-pg-confirm-action (confirmed)="toggleAlreadyUploadedDelete(file)" [disabled]="isSaving">
                                            <button type="button" class="btn btn-sm btn-danger ms-1" [attr.aria-label]="'pg-file-picker.a11y.delete' | locTranslate">
                                                <i class="fa-regular fa-trash" aria-hidden="true"></i>
                                            </button>
                                        </app-pg-confirm-action>
                                    }
                                </div>
                            </div>
                        }
                    }
                    @if (selectedFiles != null) {
                        @for (file of selectedFiles; track file) {
                            <div class="col-12 {{ multi ? 'col-sm-6 col-md-4' : '' }}">
                                <div class="PGFilePicker-Item">
                                    @if (isSaving || file.error) {
                                        <div class="PGFilePicker-Item-Status">
                                            @if (isSaving) {
                                                <app-pg-loading [isOverlay]="true" [progressRatio]="file.progress"></app-pg-loading>
                                            }
                                            @if (file.error) {
                                                <div class="PGFilePicker-Item-Status-Message text-danger">
                                                    <div class="rounded">
                                                        <b>{{file.error}}</b>
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    }
                                    <app-pg-file-preview [fileData]="file.file" [viewMode]="fileType"></app-pg-file-preview>
                                    @if (!isSaving) {
                                        <div class="PGFilePicker-Item-Actions">
                                            @if (fileType == 'images' && !file.error) {
                                                <button type="button" class="btn btn-sm btn-primary me-1" [attr.aria-label]="'pg-file-picker.a11y.crop' | locTranslate" (click)="openImageCropModal(file)">
                                                    @if (multi) {
                                                        <i class="fa-regular fa-crop-alt" aria-hidden="true"></i>
                                                    }
                                                </button>
                                            }
                                            <button type="button" class="btn btn-sm {{ multi ? 'btn-danger' : 'btn-secondary' }}" [disabled]="isSaving" [attr.aria-label]="(multi ? 'pg-file-picker.a11y.delete' : 'pg-file-picker.a11y.restore') | locTranslate" (click)="$event.stopPropagation(); $event.preventDefault(); removeSelectedFile(file);">
                                                @if (multi) {
                                                    <i class="fa-regular fa-trash" aria-hidden="true"></i>
                                                }
                                                @if (!multi) {
                                                    <i class="fa-regular fa-undo" aria-hidden="true"></i>
                                                }
                                            </button>
                                        </div>
                                    }
                                </div>
                            </div>
                        }
                    }
                </div>
            }
            @if (!readonly && !autoConfirm && hasChanges()) {
                <div class="text-end mt-1">
                    <button class="btn btn-primary ms-1" [disabled]="isSaving" (click)="saveFiles()">
                        <span>{{ 'pg-file-picker.confirm' | locTranslate }}</span>
                        <i class="fa-regular fa-check"></i>
                    </button>
                </div>
            }
        </div>
    }
</div>

<ng-template #modalEdit>
    <div class="modal-header">
        <h5 class="modal-title">{{ 'pg-file-picker.modal-edit-title' | locTranslate }}</h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="modalEditCancel()"></button>
    </div>
    <div class="modal-body">
        @if (modalEditTargetId == null) {
            <div class="text-danger">
                <i class="fa-regular fa-exclamation-triangle"></i><span class="ms-2">{{ 'pg-file-picker.modal-edit-error' | locTranslate }}</span>
            </div>
        }
        @else {
            <div class="row PGFilePicker-ModalForm">
                <div class="col-12 form-group">
                    <i class="fa-xl text-muted {{getFileCategoryIcon()}}"></i><span class="ms-2">{{modalEditTargetId}} - {{modalEditTargetName}}</span>
                </div>
                <div class="col-12 form-group">
                    <label><b>{{ 'RESOURCES.File.fields.caption.label' | locTranslate }}</b></label>
                    <textarea class="form-control" [(ngModel)]="modalEditFormData.caption"></textarea>
                </div>
                <div class="col-12 form-group">
                    <label><b>{{ 'RESOURCES.File.fields.author.label' | locTranslate }}</b></label>
                    <input class="form-control" [(ngModel)]="modalEditFormData.author">
                </div>
                <div class="col-12 form-group">
                    <label><b>{{ 'RESOURCES.File.fields.source.label' | locTranslate }}</b></label>
                    <input class="form-control" [(ngModel)]="modalEditFormData.source">
                </div>
                <div class="col-12 form-group">
                    <label><b>{{ 'RESOURCES.File.fields.license.label' | locTranslate }}</b></label>
                    <app-pg-select [options]="licenseSelectOptions" [(ngModel)]="modalEditFormData.license"></app-pg-select>
                </div>
                <div class="col-12 form-group" [appPgAnimations]="(modalEditFormData.license != 'other' ? 'ExitL' : 'EnterL')" pgAnimationsSkipFirst>
                    <label><b>{{ 'RESOURCES.File.fields.license_other.label' | locTranslate }}</b></label>
                    <input class="form-control" [(ngModel)]="modalEditFormData.license_other">
                </div>
            </div>
        }
    </div>
    <div class="modal-footer">
        <button class="btn btn-secondary" (click)="modalEditCancel()">
            {{ 'pg-file-picker.modal-edit-button-cancel' | locTranslate }}
        </button>
        <button class="btn btn-primary" (click)="modalEditSubmit()">
            {{ 'pg-file-picker.modal-edit-button-submit' | locTranslate }}
        </button>
    </div>
</ng-template>

<ng-template #modalLink>
    <div class="modal-header">
        <h5 class="modal-title">{{ 'pg-file-picker.modal-link-title' | locTranslate }}</h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="modalLinkCancel()"></button>
    </div>
    <div class="modal-body" (paste)="onModalLinkPaste($event)">
        <div class="row">
            <div class="col-12 form-group">
                <label><b>{{ 'pg-file-picker.modal-link-field-label' | locTranslate }}</b></label>
                <p class="small text-muted mb-2">{{ 'pg-file-picker.modal-link-hint' | locTranslate }}</p>
                <div class="input-group">
                    @if (getFileCategoryIcon(true); as icon) {
                        <span class="input-group-text">
                            <i class="{{icon}}"></i>
                        </span>
                    }
                    @if (modalLinkFile) {
                        <input class="form-control" [value]="'pg-file-picker.modal-link-pasted-file' | locTranslate" disabled>
                        <button type="button" class="btn btn-outline-danger" [attr.aria-label]="'pg-file-picker.a11y.clear-paste' | locTranslate" (click)="modalLinkClearFile()">
                            <i class="fa-regular fa-times" aria-hidden="true"></i>
                        </button>
                    }
                    @else {
                        <input #modalLinkInput class="form-control" [(ngModel)]="modalLinkValue" (ngModelChange)="onModalLinkValueChange()">
                    }
                </div>
            </div>
        </div>
        @if (modalLinkPreviewStatus.load) {
            <div class="row">
                <div class="col-12">
                    <app-pg-file-preview [fileData]="modalLinkFile || modalLinkValue" [viewMode]="fileType" (success)="modalLinkPreviewStatus.success = true;" (error)="modalLinkPreviewStatus.error = true"></app-pg-file-preview>
                </div>
            </div>
        }
        @if (modalLinkFile) {
            <div class="row">
                <div class="col-12 form-group mt-3">
                    <label><b>{{ 'pg-file-picker.modal-link-filename-label' | locTranslate }}</b></label>
                    <input class="form-control" [(ngModel)]="modalLinkFileName">
                </div>
            </div>
        }
        @if (modalLinkPreviewStatus.error) {
            <div class="alert alert-danger mt-2 mb-0" role="alert">
                {{ 'pg-file-picker.modal-link-error' | locTranslate }}
            </div>
        }
    </div>
    <div class="modal-footer">
        <button class="btn btn-secondary" (click)="modalLinkCancel()">
            {{ 'pg-file-picker.modal-link-button-cancel' | locTranslate }}
        </button>
        <button class="btn btn-primary" [disabled]="!modalLinkPreviewStatus.success" (click)="modalLinkSubmit()">
            {{ 'pg-file-picker.modal-link-button-submit' | locTranslate }}
        </button>
    </div>
</ng-template>